export default "__VITE_ASSET__B23tgIoi__"